import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupFiles'
})
export class GroupFilesPipe implements PipeTransform {
  transform(files: any[] | null, groupSize: number): any[][] {
    const groups: any[][] = [];
    
    for (let i = 0; i < files!.length; i += groupSize) {
      groups.push(files!.slice(i, i + groupSize));
    }
    return groups;
  }
}